module.exports = __webpack_public_path__ + "dist/assets/img/arduino.8c06b20b.svg";